var EPaddleCountryKeyEU = /*#__PURE__*/ function(EPaddleCountryKeyEU) {
    EPaddleCountryKeyEU["Austria"] = "AT";
    EPaddleCountryKeyEU["Belgium"] = "BE";
    EPaddleCountryKeyEU["Bulgaria"] = "BG";
    EPaddleCountryKeyEU["Croatia"] = "HR";
    EPaddleCountryKeyEU["Cyprus"] = "CY";
    EPaddleCountryKeyEU["CzechRepublic"] = "CZ";
    EPaddleCountryKeyEU["Denmark"] = "DK";
    EPaddleCountryKeyEU["Germany"] = "DE";
    EPaddleCountryKeyEU["Estonia"] = "EE";
    EPaddleCountryKeyEU["Finland"] = "FI";
    EPaddleCountryKeyEU["Frankreich"] = "FR";
    EPaddleCountryKeyEU["Greece"] = "GR";
    EPaddleCountryKeyEU["Hungary"] = "HU";
    EPaddleCountryKeyEU["Ireland"] = "IE";
    EPaddleCountryKeyEU["Italy"] = "IT";
    EPaddleCountryKeyEU["Latvia"] = "LV";
    EPaddleCountryKeyEU["Lithuania"] = "LT";
    EPaddleCountryKeyEU["Luxembourg"] = "LU";
    EPaddleCountryKeyEU["Malta"] = "MT";
    EPaddleCountryKeyEU["Netherlands"] = "NL";
    EPaddleCountryKeyEU["Poland"] = "PL";
    EPaddleCountryKeyEU["Portugal"] = "PT";
    EPaddleCountryKeyEU["Romania"] = "RO";
    EPaddleCountryKeyEU["Sweden"] = "SE";
    EPaddleCountryKeyEU["Slovakia"] = "SK";
    EPaddleCountryKeyEU["Slovenia"] = "SI";
    EPaddleCountryKeyEU["Spain"] = "ES";
    return EPaddleCountryKeyEU;
}(EPaddleCountryKeyEU || {});
export { EPaddleCountryKeyEU };
